import { DeliveryType } from '@/resources/enums'
import { TURBO_COLORS, TurboColor } from '@/resources/enums/orders'
import emotionTheme from '@/styles/theme.ts'
import {
  IN_SEPARATION_SLA_MINUTES,
  IN_SEPARATION_SLA_MINUTES_ECONOMY_SHIPPING,
  IN_SEPARATION_SLA_MINUTES_TURBO,
  ON_GOING_SLA_MINUTES,
  ON_GOING_SLA_MINUTES_ECONOMY_SHIPPING,
  ON_GOING_SLA_MINUTES_TURBO,
} from '@/resources/constants/orders'
import { OrdersColumnsLabels } from '@/pages/Orders/constants'
import { OrderStatus } from '@/resources/enums/orderStatus'

export const getCardColorByType = (
  type: DeliveryType,
  turboColor?: TurboColor
) => {
  switch (type) {
    case DeliveryType.TURBO:
      return turboColor
        ? TURBO_COLORS[turboColor]
        : TURBO_COLORS[TurboColor.YELLOW]
    case DeliveryType.SCHEDULED:
      return '#6A21B4'
    case DeliveryType.PICKUP:
      return emotionTheme.ds.ColorBaseBlueLevel6
    case DeliveryType.ECONOMY:
      return emotionTheme.ds.ColorBaseBlack
    case DeliveryType.RECEIVE:
    default:
      return emotionTheme.ds.ColorBaseGreyLevel3
  }
}

export const getProgressCircleCircumference = (radius?: string | number) => {
  const numRadius = Number(radius)
  return isNaN(numRadius) ? 0 : Math.round(2 * Math.PI * numRadius)
}

export const getInSeparationSlaMinutes = (deliveryType: DeliveryType) => {
  if (deliveryType === DeliveryType.TURBO) {
    return IN_SEPARATION_SLA_MINUTES_TURBO
  }

  if (deliveryType === DeliveryType.ECONOMY) {
    return IN_SEPARATION_SLA_MINUTES_ECONOMY_SHIPPING
  }

  return IN_SEPARATION_SLA_MINUTES
}

export const getOnGoingSlaMinutes = (deliveryType: DeliveryType) => {
  if (deliveryType === DeliveryType.TURBO) {
    return ON_GOING_SLA_MINUTES_TURBO
  }

  if (deliveryType === DeliveryType.ECONOMY) {
    return ON_GOING_SLA_MINUTES_ECONOMY_SHIPPING
  }

  return ON_GOING_SLA_MINUTES
}

export const getOrderColumnByStatus = (
  status: OrderStatus
): OrdersColumnsLabels | null => {
  switch (status) {
    case OrderStatus.PENDING:
    case OrderStatus.TRANSFERED:
      return OrdersColumnsLabels.NEW_ORDERS
    case OrderStatus.POC_ACCEPTED:
    case OrderStatus.DM_ACCEPTED:
      return OrdersColumnsLabels.IN_SEPARATION_ORDERS
    case OrderStatus.DM_PICKED_UP:
    case OrderStatus.DM_EN_ROUTE:
      return OrdersColumnsLabels.ON_GOING_ORDERS
    default:
      return null
  }
}
